/**
 * Prezentacja salda kredytów w nawigacji.
 *
 * `useCredits` zwraca `balance: number | null`, gdzie `null` znaczy „saldo jeszcze
 * nie dojechało z API" — a nie „zero kredytów". Zwijanie tego do `?? 0` pokazywało
 * płacącemu agentowi „0 kredytów" przez cały czas ładowania (na zimnym wejściu
 * mierzone ~6,8 s), czyli dokładnie wtedy, gdy patrzy na ekran po otwarciu aplikacji.
 * Dlatego stan „nie wiem" ma własny, neutralny znak zamiast liczby.
 */

import { pluralPl } from "@/lib/plural";

/** Znak pokazywany, dopóki saldo nie jest znane. */
export const UNKNOWN_CREDITS_LABEL = "—";

/** Liczba kredytów do wyświetlenia albo neutralny znak, gdy saldo jeszcze nie dojechało. */
export function formatCredits(credits: number | null): string {
  return credits === null ? UNKNOWN_CREDITS_LABEL : String(credits);
}

/** Podpowiedź (`title`) licznika kredytów — bez „null kredytów" w stanie ładowania. */
export function creditsTitle(credits: number | null, withTopUp: boolean): string {
  if (credits === null) return "Sprawdzamy stan kredytów…";
  const noun = pluralPl(credits, "kredyt", "kredyty", "kredytów");
  return withTopUp ? `${credits} ${noun} — doładuj` : `${credits} ${noun}`;
}

/**
 * Komunikat na czas, gdy saldo nie jest jeszcze znane.
 *
 * Na produkcji to okno trwa do ~13 s po wejściu na ekran narzędzia (i wraca po
 * każdym odświeżeniu tokenu). Kliknięcie „Generuj" w tym czasie odrzucało
 * użytkownika z 245 kredytami komunikatem „Brakuje 3 kredytów" i przenosiło go
 * na cennik. Dopóki saldo jest nieznane, operacji nie wolno odrzucić jako
 * braku kredytów — trzeba poprosić o chwilę.
 */
export const CREDITS_LOADING_MESSAGE = "Sprawdzamy stan kredytów — spróbuj za chwilę.";

